var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 61,
    viewBox: "0 0 79 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2071_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.093 30.6914H2.74476C1.5967 30.6914 0.666016 31.6221 0.666016 32.7701V58.1003C0.666016 59.2483 1.5967 60.179 2.74476 60.179H10.093C11.2411 60.179 12.1718 59.2483 12.1718 58.1003V32.7701C12.1718 31.6221 11.2411 30.6914 10.093 30.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9172 30.832H16.569C15.4209 30.832 14.4902 31.7627 14.4902 32.9108V58.2409C14.4902 59.3889 15.4209 60.3196 16.569 60.3196H23.9172C25.0653 60.3196 25.996 59.3889 25.996 58.2409V32.9108C25.996 31.7627 25.0653 30.832 23.9172 30.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7769 26.1998V18.8903C39.7769 17.7419 38.5412 16.8115 37.0173 16.8115H3.42556C1.90163 16.8115 0.666016 17.7419 0.666016 18.8903V26.2361C0.666016 27.3845 1.90163 28.3149 3.42556 28.3149H28.2711V57.7298C28.2711 59.1592 29.2014 60.3197 30.3498 60.3197H37.6957C38.8441 60.3197 39.7744 59.1616 39.7744 57.7298V26.1998H39.7769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6105 21.7924H69.2647H55.0551V2.6452C55.0551 1.36113 54.1247 0.319336 52.9764 0.319336H45.6305C44.4821 0.319336 43.5518 1.36113 43.5518 2.6452V30.9723V31.217C43.5518 31.8735 43.8813 32.4574 44.3949 32.8378C44.7413 33.1237 45.1677 33.2957 45.6305 33.2957H67.1883V48.8112H45.8049C44.5596 48.8112 43.5518 49.7415 43.5518 50.8899V58.2358C43.5518 59.3841 44.5596 60.3145 45.8049 60.3145H76.6154C77.7638 60.3145 78.6941 59.0983 78.6941 57.5961V24.5083C78.6941 23.0086 77.7638 21.79 76.6154 21.79L76.6105 21.7924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2071_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.023,
    height: 60,
    fill: "white",
    transform: "translate(0.666016 0.319336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb);
export default __webpack_public_path__ + "static/media/mb.a3973929c49a8b82e1d914e5c8ca12ec.svg";
export { ForwardRef as ReactComponent };